import { Component } from '@opten/compiler/metadata/component';
import { addClass } from '@opten/dom/add-class';
import { hasClass } from '@opten/dom/has-class';

@Component({ className: 'alert' })
export class AlertComponent {
	constructor(private element: HTMLElement) {
		const closer = this.element.querySelector('.close');
		if (closer) {
			closer.addEventListener('click', (e) => {
				e.preventDefault();
				this.close();
			});
		}
		this.element.addEventListener('click', (e) => {
			e.preventDefault();
			this.close();
		});
		setTimeout(() => {
			this.close();
		}, 10000);
	}

	private close() {
		addClass(this.element, 'is-hidden');
		setTimeout(() => {
			this.element.remove();
		}, 2000);
	}
}
